import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation, useHistory } from 'react-router-dom'
import ButtonWhite from 'components/design/Form/ButtonWhite'
import ButtonBlack from 'components/design/Form/ButtonBlack'
import _ from 'lodash'
import style from './style.module.scss'

const VerificationEmailSent = ({ subTitle, footer }) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const { search } = useLocation()
  const [registeredEmail, setRegisteredEmail] = useState('')
  useEffect(() => {
    const searchParams = new URLSearchParams(search)
    const email = searchParams.get('email')
    setRegisteredEmail(email)

    if (!email) {
      history.push('/signup')
    }
  }, [registeredEmail, history, search])

  const onResendEmail = () => {
    dispatch({
      type: 'user/REGISTER_EMAIL',
      payload: { email: _.replace(registeredEmail, ' ', '+'), resendEmail: true },
    })
  }

  return (
    <div className={style.cometchatVerifyEmail}>
      <div className={style.cometchatVerifyEmailContentWrapper}>
        <div className={style.cometchatVerifyEmailHeader}>
          <div className={style.cometchatVerifyEmailTitle}>Verify Email</div>
          <div className={style.cometchatVerifyEmailSubtitle}>{subTitle}</div>
        </div>
        <div className={style.cometchatVerifyEmailContent}>
          <div className={style.cometchatVerifyEmailActions}>
            <a
              href="https://mail.google.com/"
              target="_blank"
              rel="noopener noreferrer"
              className={style.cometchatVerifyEmailActionLink}
            >
              <ButtonWhite
                buttonText={
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <img
                      className={style.icon}
                      src="/resources/images/v2-dashboard/google.svg"
                      alt="Gmail"
                    />
                    <div>Open Gmail</div>
                  </div>
                }
                buttonStyles={{
                  height: '44px',
                  fontSize: '16px',
                  fontWeight: '600',
                }}
                buttonType="button"
              />
            </a>

            <a
              href="https://outlook.live.com/mail"
              target="_blank"
              rel="noopener noreferrer"
              className={style.cometchatVerifyEmailActionLink}
            >
              <ButtonWhite
                buttonText={
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <img
                      className={style.icon}
                      src="/resources/images/v2-dashboard/outlook.svg"
                      alt="Outlook"
                    />
                    <div>Open Outlook</div>
                  </div>
                }
                buttonStyles={{
                  height: '44px',
                  fontSize: '16px',
                  fontWeight: '600',
                }}
                buttonType="button"
              />
            </a>
            <a
              href="https://mail.yahoo.com/"
              target="_blank"
              rel="noopener noreferrer"
              className={style.cometchatVerifyEmailActionLink}
            >
              <ButtonWhite
                buttonText={
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <img
                      className={style.icon}
                      src="/resources/images/v2-dashboard/yahoo.svg"
                      alt="yahoo"
                    />
                    <div>Open Yahoo</div>
                  </div>
                }
                buttonStyles={{
                  height: '44px',
                  fontSize: '16px',
                  fontWeight: '600',
                }}
                buttonType="button"
              />
            </a>
          </div>
          <ButtonBlack
            buttonStyles={{
              height: '44px',
              fontSize: '16px',
            }}
            holderStyles={{ width: '100%' }}
            buttonText="Resend Email"
            buttonType="button"
            onClick={onResendEmail}
          />
        </div>
      </div>
      {footer}
    </div>
  )
}

export default VerificationEmailSent
